import { z } from 'zod';

export const newsletterSchema = z.object({
  email: z.string().trim().email(),
});

export type NewsletterFormData = z.infer<typeof newsletterSchema>;
